import { Observable } from "rxjs";
import { VisibleOn } from "../visible-on.model";
import { DynamicCol } from "./dynamic-col.model";

export class DynamicRow<T> {

    columns?: Array<DynamicCol<T>>;
    visible?: boolean;
    visibleObserver?: Observable<boolean>;
    visibleOn?: VisibleOn;
    switchProperty?: string;
    switchDefaultValues?: string;
    styleClass?: string;
    formProperty?: string;
    isArray?: boolean;
    type: 'generic' | 'item' | 'object' | 'template' | 'tabview' | 'switch' | 'panel' | 'nested-columns';


    constructor(source: Partial<DynamicRow<T>>) {
        this.visible = true;
        this.type = "generic";
        Object.assign(this, source);

        this.visibleObserver?.subscribe(value => {
            this.visible = value;
        });
    }

    /**
     * The function sets up an observer for a boolean value and updates the "visible" property based on
     * the observed value.
     * @param observer - An Observable<boolean> object that will emit boolean values.
     */
    setVisibleObserver(observer: Observable<boolean>) {

        this.visibleObserver = observer;

        this.visibleObserver.subscribe(value => {
            this.visible = value;
        });
    }
}